'use strict';

import Component from 'generic.basecomponent';
import gaHelper from 'ga-helper';

export default class GaEvent extends Component {
    constructor(el) {
        super(el);
        this.init();
    }

    init() {
        this.container.addEventListener('click', this.onClick.bind(this));
    }

    onClick(e) {
        if (typeof e !== 'undefined' && typeof e.stopPropagation === "function") {
            e.stopPropagation();
        }

        let category = this.container.getAttribute('data-tracking-category') || 'n/a';
        let action = this.container.getAttribute('data-tracking-action') || 'n/a';
        let label = this.container.getAttribute('data-tracking-label') || 'n/a';

        gaHelper.ga('send', 'event', category, action, label);
    }
}



// WEBPACK FOOTER //
// ./app/components/ga-tracker/js/generic.ga-event.js